module.exports = __webpack_public_path__ + "static/media/PoV.d7102294.mov";